import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { UseGetTour, UseSaveTour } from "../../api/calls/Queries.ts";

const baseTourData = {
  title: "Nuovo tour",
  fov: 75,
  scenes: [],
  maps: [],
  groups: [
    {
      id: Math.floor(100000 + Math.random() * 900000),
      name: "Primo gruppo",
      scenes: [],
      mainColor: "#bada55",
      textColor: "#222",
    },
  ],
  popups: [],
  isNew: true,
};

function NewTourPage(props: { tourID: number }) {
  const { tourID } = props;
  const { data: tourData, refetch } = UseGetTour(tourID);

  const { mutateAsync: saveTourData, isPending: isSaving } = UseSaveTour();

  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.setQueryData(["GetTour", tourID], {
      ...baseTourData,
      id: tourID,
    });
  }, [queryClient, tourID]);

  return (
    <div className="new-tour-page">
      {tourData && (
        <form
          onSubmit={(e) => {
            e.preventDefault();

            saveTourData(
              { ...tourData, isNew: undefined },
              {
                onSuccess: () => refetch(),
              }
            );
          }}
        >
          <h1>Nuovo tour</h1>
          <div>
            ID: <span>{tourID}</span>
          </div>
          <br />
          <label>
            Inserire un titolo
            <input
              maxLength={32}
              required
              type="text"
              placeholder="Nuovo Tour"
              onChange={(e) => {
                queryClient.setQueryData(["GetTour", tourID], {
                  ...tourData,
                  title: e.target.value,
                });
              }}
            />
          </label>
          <button id="create-tour" type="submit" disabled={isSaving}>
            {isSaving ? "Caricando" : "Crea"}
          </button>
        </form>
      )}
    </div>
  );
}

export default NewTourPage;
